<template>
  <div class="social-media">
    <p>Follow Me on</p>
    <div class="social">
      <a v-if="false" href="https://facebook.com/cornerQR" class="facebook" target="_blank">
        <svg
          width="20"
          height="20"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M14.6725 0.5H1.3275C0.870625 0.5 0.5 0.870625 0.5 1.3275V14.6725C0.5 15.13 0.870625 15.5 1.3275 15.5H8.51125V9.69125H6.55562V7.42812H8.51125V5.75625C8.51125 3.81938 9.695 2.76562 11.4231 2.76562C12.2512 2.76562 12.9631 2.82625 13.1706 2.85375V4.87875H11.97C11.0325 4.87875 10.85 5.32938 10.85 5.98563V7.43H13.09L12.7994 9.69875H10.85V15.5H14.6719C15.13 15.5 15.5 15.13 15.5 14.6725V1.3275C15.5 0.870625 15.13 0.5 14.6725 0.5Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </a>
      <a v-if="true"
        href="https://instagram.com/d3rriana"
        class="instagram"
        target="_blank"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M8 5.39707C6.56641 5.39707 5.39649 6.56699 5.39649 8.00058C5.39649 9.43417 6.56641 10.6041 8 10.6041C9.4336 10.6041 10.6035 9.43417 10.6035 8.00058C10.6035 6.56699 9.4336 5.39707 8 5.39707ZM15.8086 8.00058C15.8086 6.92246 15.8184 5.8541 15.7578 4.77792C15.6973 3.52792 15.4121 2.41855 14.498 1.50449C13.582 0.588471 12.4746 0.305268 11.2246 0.244722C10.1465 0.184175 9.07813 0.19394 8.00195 0.19394C6.92383 0.19394 5.85547 0.184175 4.7793 0.244722C3.5293 0.305268 2.41992 0.590425 1.50586 1.50449C0.589845 2.4205 0.306642 3.52792 0.246095 4.77792C0.185548 5.85605 0.195314 6.92441 0.195314 8.00058C0.195314 9.07675 0.185548 10.1471 0.246095 11.2232C0.306642 12.4732 0.591798 13.5826 1.50586 14.4967C2.42188 15.4127 3.5293 15.6959 4.7793 15.7564C5.85742 15.817 6.92578 15.8072 8.00195 15.8072C9.08008 15.8072 10.1484 15.817 11.2246 15.7564C12.4746 15.6959 13.584 15.4107 14.498 14.4967C15.4141 13.5807 15.6973 12.4732 15.7578 11.2232C15.8203 10.1471 15.8086 9.07871 15.8086 8.00058ZM8 12.0064C5.7832 12.0064 3.99414 10.2174 3.99414 8.00058C3.99414 5.78378 5.7832 3.99472 8 3.99472C10.2168 3.99472 12.0059 5.78378 12.0059 8.00058C12.0059 10.2174 10.2168 12.0064 8 12.0064ZM12.1699 4.76621C11.6523 4.76621 11.2344 4.34824 11.2344 3.83066C11.2344 3.31308 11.6523 2.89511 12.1699 2.89511C12.6875 2.89511 13.1055 3.31308 13.1055 3.83066C13.1056 3.95356 13.0815 4.07528 13.0346 4.18886C12.9876 4.30243 12.9187 4.40563 12.8318 4.49253C12.7449 4.57944 12.6417 4.64834 12.5281 4.69531C12.4146 4.74227 12.2928 4.76636 12.1699 4.76621Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
          v-if="false"
        href="https://linkedin.com/company/heartbeatfam"
        class="linkedin"
        target="_blank"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M13.2794 13.2825H11.0581V9.80188C11.0581 8.97188 11.0413 7.90375 9.90063 7.90375C8.7425 7.90375 8.56563 8.80688 8.56563 9.74063V13.2825H6.34437V6.125H8.47813V7.10063H8.50688C8.805 6.53813 9.53 5.94438 10.6131 5.94438C12.8637 5.94438 13.28 7.42563 13.28 9.35375V13.2825H13.2794ZM3.83562 5.14563C3.12063 5.14563 2.54625 4.56687 2.54625 3.855C2.54625 3.14375 3.12125 2.56562 3.83562 2.56562C4.54812 2.56562 5.12563 3.14375 5.12563 3.855C5.12563 4.56687 4.5475 5.14563 3.83562 5.14563ZM4.94938 13.2825H2.72187V6.125H4.94938V13.2825ZM14.3906 0.5H1.60688C0.995 0.5 0.5 0.98375 0.5 1.58062V14.4194C0.5 15.0169 0.995 15.5 1.60688 15.5H14.3888C15 15.5 15.5 15.0169 15.5 14.4194V1.58062C15.5 0.98375 15 0.5 14.3888 0.5H14.3906Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMedia"
};
</script>

<style lang="scss" scoped>
.social-media {
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #000000;
    margin-bottom: 6px;
    margin-left: 4px;
  }
  .social {
    display: flex;
    column-gap: 16px;
  }
  a {
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      background: #8026ce;
      box-shadow: 0px 4px 32px rgba(255, 255, 255, 0.3);
    }
  }
}

a.facebook:hover {
  background: #1977f2;
  color: #ffffff;
}

a.twitter:hover {
  background: #1d9bf0;
  color: #ffffff;
}

a.linkedin:hover {
  background: #0a66c2;
  color: #ffffff;
}

a.instagram:hover {
  background: #864db9;
  color: #ffffff;
}

@media (max-width: 767px) {
  .social-media {
  }
}
</style>
